import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { FormField, Icon, Input } from '..';
import './Search.css';

const Search = ({
  name,
  errors,
  touched,
  onBlur,
  onChange,
  onSubmit,
  placeholder,
  value,
  isSearchView,
}) => {
  const onEnter = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };
  const onClick = (e) => {
    e.preventDefault();
    if (value && !errors.searchPolicy) {
      onSubmit();
    }
  };

  return (
    <span
      className={clsx(
        'alf-search-span',
        errors?.searchPolicy ? 'error' : 'success',
      )}
    >
      <div className="alf-search-div">
        <Icon
          id="search"
          name="search"
          fontSize={20}
          color="grey"
          onClick={onClick}
          disabled={errors?.searchPolicy ? true : false}
          className={clsx(
            'alf-search-icon',
            errors?.searchPolicy ? 'error' : 'success',
          )}
        />
      </div>
      <FormField
        error={
          touched?.searchPolicy && isSearchView ? errors?.searchPolicy : ''
        }
        onKeyPress={onEnter}
      >
        <Input
          name={name}
          placeholder={placeholder}
          type="text"
          id="search-input"
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          error={!!errors?.searchPolicy && !!touched?.searchPolicy}
          success={!errors?.searchPolicy && !!touched?.searchPolicy}
          className="!w-[calc(100%-22px)] !h-[36px] !border-none focus:!border-none focus:!ring-0 !pt-[8px] p-0 "
        />
      </FormField>
    </span>
  );
};

Search.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default Search;
